import { ApiService } from './api.service'

export enum AbsenceType {
  VACATION = 'VACATION',
  SICK_LEAVE = 'SICK_LEAVE',
  UNPAID_LEAVE = 'UNPAID_LEAVE',
  OTHER = 'OTHER',
}

export enum AbsenceRequestStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export interface AbsenceRequest {
  id: string
  userId: string
  type: AbsenceType
  startDate: string
  endDate: string
  reason?: string
  status: AbsenceRequestStatus
  reviewedBy?: string
  reviewedAt?: Date
  reviewComment?: string
  createdAt: Date
  updatedAt: Date
  userFirstName?: string
  userLastName?: string
  reviewerFirstName?: string
  reviewerLastName?: string
}

export interface CreateAbsenceRequestDto {
  type: AbsenceType
  startDate: string
  endDate: string
  reason?: string
}

export interface UpdateAbsenceRequestDto {
  status: AbsenceRequestStatus.APPROVED | AbsenceRequestStatus.REJECTED
  reviewComment?: string
}

class AbsenceService extends ApiService {
  async createRequest(userId: string, dto: CreateAbsenceRequestDto): Promise<AbsenceRequest> {
    return this.handleResponse(
      this.api.post<AbsenceRequest>(`/absence/users/${userId}/requests`, dto)
    )
  }

  async getMyRequests(userId: string): Promise<AbsenceRequest[]> {
    return this.handleResponse(this.api.get<AbsenceRequest[]>(`/absence/users/${userId}/requests`))
  }

  async getAllRequests(): Promise<AbsenceRequest[]> {
    return this.handleResponse(this.api.get<AbsenceRequest[]>('/absence/requests'))
  }

  async updateRequestStatus(
    requestId: string,
    status: AbsenceRequestStatus.APPROVED | AbsenceRequestStatus.REJECTED,
    reviewComment?: string
  ): Promise<AbsenceRequest> {
    return this.handleResponse(
      this.api.patch<AbsenceRequest>(`/absence/requests/${requestId}`, {
        status,
        reviewComment,
      })
    )
  }
}

export const absenceService = new AbsenceService()
